import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';

import './hosDailyBox.scss';

interface Props {
  subTitle: string;
  addClassName?: string;
}

export const HosDailyBox: React.FC<PropsWithChildren<Props>> = ({ subTitle, addClassName, children }) => {
  return (
    <div className={classNames('daily-header-box', addClassName)}>
      <div className="content">
        <span className="sub-title">{subTitle}</span>
        {children}
      </div>
    </div>
  );
};
